import React from "react";
import LoadingOverlay from "react-loading-overlay";
import RingLoader from "react-spinners/RingLoader";

const Spinner = ({ isLoading }) => {
  return (
    <LoadingOverlay
      className="loading-spinner"
      text="Триває обробка даних"
      active={isLoading}
      spinner={
        <div className="spinner">
          <RingLoader className="spinner" color={"#50e3c2"} />
        </div>
      }
    />
  );
};

export default Spinner;



// WEBPACK FOOTER //
// src/helpers/Spinner.js